import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./style/Style.scss";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import ChatPanel from "./ChatPanel";

// Import ToastContainer from react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Make sure to import the styles for the toast

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ChatPanel />} />
      </Routes>

      {/* Add ToastContainer here to enable toast notifications */}
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
